// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__3hUnh","header":"Navbar_header__w-4-f"};